import { render, staticRenderFns } from "./InfoAccess.vue?vue&type=template&id=62c273be&scoped=true"
import script from "./InfoAccess.vue?vue&type=script&lang=js"
export * from "./InfoAccess.vue?vue&type=script&lang=js"
import style0 from "./InfoAccess.vue?vue&type=style&index=0&id=62c273be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c273be",
  null
  
)

export default component.exports